(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["miralleve-mobile-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    function hydrate(drawer) {
      if (!drawer || drawer.dataset.mlMenuImagesLoaded === 'true') return;
      drawer.querySelectorAll('template[data-ml-menu-image]').forEach(function (template) {
        template.replaceWith(template.content.cloneNode(true));
      });
      drawer.dataset.mlMenuImagesLoaded = 'true';
    }

    function init() {
      var drawer = document.getElementById('header-sidebar-menu');
      if (!drawer || drawer.dataset.mlMenuLazyReady === 'true') return;
      drawer.dataset.mlMenuLazyReady = 'true';

      var observer = new MutationObserver(function () {
        if (drawer.hasAttribute('open')) hydrate(drawer);
      });
      observer.observe(drawer, { attributes: true, attributeFilter: ['open'] });

      var trigger = document.querySelector('[aria-controls="header-sidebar-menu"]');
      if (trigger) {
        trigger.addEventListener('click', function () {
          requestAnimationFrame(function () { hydrate(drawer); });
        }, { once: true });
      }

      if (window.Shopify && window.Shopify.designMode) hydrate(drawer);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
